export default "__VITE_ASSET__7x7OlY3y__"